

























import { Button } from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'

import ConfirmationModal from '@/components/modals/ConfirmationModal.vue'

import ConfirmationModalTypes from '@/models/confirmation-modal-types'
import CreditCard from '@/models/credit-card'

@Component({
  components: {
    ConfirmationModal,
    [Button.name]: Button,
  },
})
export default class RemoveCreditCardModal extends Vue {
  @Prop() card!: CreditCard

  get confirmationModalTypes() {
    return ConfirmationModalTypes
  }
}
